module.exports = __webpack_public_path__ + "static/media/6_2.4b6b04a3.jpg";